import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5ashuqcsm4: FaireBrandEntity = {
  token: "b_5ashuqcsm4",
  type: "brand",
  name: "Frontier Co-op",
  avatarUrl:
    "https://cdn.faire.com/fastly/603392b422d38495ce71e57625120372590e540cc0efaf2acc6db5733db46e8a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e0280a54660f53593dd9e57c4a1d31273abcb779fc09a3a8dec97d78da467de0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/603392b422d38495ce71e57625120372590e540cc0efaf2acc6db5733db46e8a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e0280a54660f53593dd9e57c4a1d31273abcb779fc09a3a8dec97d78da467de0.jpeg",
  location: "Norway, IA, USA",
  minimumOrderDollars: 137,
  rating: 4.9,
  reviewCount: 28,
  isInsider: true,
  description:
    "Frontier Co-op® is a values-driven cooperative of 65,000 member owners who believe that business can be a powerful force for good. \n\nSince 1976, Frontier Co-op has been a trusted partner in supplying high-quality, natural and organic botanicals to the food service industry. We offer a comprehensive selection of premium herbs, spices, seasonings, and teas—grown to deliver exceptional flavor, responsibly sourced. \n\nAs a member-owned cooperative with over 60,000 members, we are deeply committed to ethical sourcing, sustainability, and community impact. Our Well Earth® program fosters long-term partnerships with growers around the world, ensuring traceability, regenerative organic farming practices, and consistent botanical quality. We also invest in the communities we serve, from inclusive employment initiatives in rural Iowa to global efforts that empower smallholder farmers. \n\nWith decades of experience and a scalable supply chain, Frontier Co-op delivers botanicals and custom blends that help create flavorful, responsible, and memorable dining experiences. \n\nRetailers choose Frontier Co-op® for our commitment to quality and transparency, unique product assortment, and mission to put people and planet before profits.\n\nAdd Frontier Co-op® to your assortment to offer products that are flavorful, responsibly sourced and grounded in quality and integrity.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:48.249Z",
    importedBy: "entity-db-cli",
  },
};
